import { CancelablePromise, apiRequest } from '../../../main/services/api'
import { ActionTypes } from '../../futures/constants/constants'
import AppDispatcher from '../../futures/dispatcher/appDispatcher'
import RowsStore from '../../futures/stores/rowsStore'
import { TileMap } from '../types'

var getCryptoUrl = function () {
  var timeframe = RowsStore.getTimeframe()
  return '/api/crypto_all.ashx?timeframe=' + timeframe
}

let _lastRequest: CancelablePromise<any> | null = null

const actions = {
  initTiles(tiles: TileMap) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.INIT_TILES,
      tiles,
    })
  },

  async update(data: any) {
    if (data) {
      AppDispatcher.handleViewAction({
        type: ActionTypes.UPDATE_DATA,
        tiles: data,
      })
      return
    }

    _lastRequest?.cancel?.()
    _lastRequest = apiRequest(getCryptoUrl())
    const tiles = await _lastRequest
    if (tiles) {
      AppDispatcher.handleServerAction({
        type: ActionTypes.UPDATE_DATA,
        tiles,
      })
    }
  },

  async changeTimeframe(timeframe: string) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.CHANGE_TIMEFRAME_STARTED,
      period: timeframe,
    })

    _lastRequest?.cancel?.()
    _lastRequest = apiRequest(getCryptoUrl())
    const data = await _lastRequest
    if (data) {
      AppDispatcher.handleServerAction({
        type: ActionTypes.UPDATE_DATA,
        tiles: data,
      })
      AppDispatcher.handleServerAction({
        type: ActionTypes.CHANGE_TIMEFRAME_COMPLETED,
      })
    }
  },
}

export default actions
